module.exports = __webpack_public_path__ + "img/milan.442c17f4.png";